module.exports = __webpack_public_path__ + "static/media/04.be8fdf39.jpg";